export const environment = {
  production: false,
  entorno: 'ENTORNO TEST',
  //timeOut: 600000,              // Milisegundos de inactividad que provocan la DESCONEXIÓN automática (10min = 600000 ms)
  timeOut: (60 * 60 * 1000),      // Milisegundos de inactividad que provocan la DESCONEXIÓN automática (1hora = 60minutos * 60 segundos * 1000 ms)
  timeRefreshCampanyas: 5000,     // Refesco automático de los datos de campañas. 5000 milisegundos = 5 segundos
  timeRefreshPda: 5000,           // Refesco automático de los datos de listados en PDA. 5000 milisegundos = 5 segundos  
  timeAutoSave: 120000,           // Auto-guardado en formularios. 120000 milisegundos = 2 minutos

  apiErrorAuth: 'El sistema ha devuelto un error. <br><i>Asegurate de estar autorizado para hacer esta operación</i>',
  defaultTema: 'default-dark.css',


  // URL absoluta de la intranet de cliente
  url_cliente: 'https://clientes.test.innovacen.com',

  // URL de la API
  apiURL: 'https://api.test.innovacen.com/api',

  // Directorios
  dataDir: 'https://api.test.innovacen.com/data',
  fotoDir: 'https://api.test.innovacen.com/data/fotos',
  pdfDir: 'https://api.test.innovacen.com/data/pdfs',
  xlsDir: 'https://api.test.innovacen.com/data/xls',


  // roles
  rolesAdministracion: ['sa', 'admin', 'admin_02'],
};
